/**
 *
 * Mixin
 *
 */
import { mapMutations } from 'vuex';
import $ from 'jquery';

let promiseComponentPlayer;

const getComponentPlayer = () => {
  promiseComponentPlayer = import('@/components/Player.vue');
  return promiseComponentPlayer;
};

const QL_TAG_CLASSNAME = 'ql-tag-blot';

// ClassRestrictionMixin
export const TimetagInHtmlMixin = {
  components: {
    Player: getComponentPlayer,
  },

  data: () => {
    return {
      $timetag: null,

      currentVideo: {},
      isShowPlayer: false,

      playerStartTime: 0,
    };
  },

  methods: {
    ...mapMutations({
      mm_UPDATE_USER_INFO_SUCCESS: 'UPDATE_USER_INFO_SUCCESS',
      mm_UPDATE_USER_INFO_PROFILE_SUCCESS: 'UPDATE_USER_INFO_PROFILE_SUCCESS',
    }),

    openTimeTagPlayer() {
      this.isShowPlayer = true;
    },

    closeTimeTagPlayer() {
      this.isShowPlayer = false;
    },

    //
    setCurrentVideo() {
      //
    },

    jqHasClass($el) {
      return $el.hasClass(QL_TAG_CLASSNAME);
    },

    jqParents($el) {
      return $el.parents(`.${QL_TAG_CLASSNAME}`);
    },

    detectTimetag(e) {
      const $el = $(e.target);
      return this.jqHasClass($el) || this.jqParents($el).length;
    },

    setElTimetag(e) {
      let $el = $(e.target);
      if (this.jqHasClass($el)) {
        this.$timetag = $el;
      } else {
        $el = this.jqParents($el);
        if ($el.length) {
          this.$timetag = $el;
        } else {
          this.$timetag = null;
        }
      }
    },

    async setTimetagVideoAndOpenPlayer(payload) {
      this.mm_UPDATE_USER_INFO_SUCCESS({
        defaultSpeed: Number(this.$timetag.attr('data-speed')),
      });
      this.mm_UPDATE_USER_INFO_PROFILE_SUCCESS({
        videoSpeed: Number(this.$timetag.attr('data-speed')),
      });
      this.playerStartTime = Number(this.$timetag.attr('data-time'));
      this.setCurrentVideo(payload);
      await promiseComponentPlayer;
      await this.$nextTick();
      this.openTimeTagPlayer();
    },

    clickTimeTag(payload, e) {
      this.setElTimetag(e);
      if (this.$timetag) {
        this.setTimetagVideoAndOpenPlayer(payload);
      }
    },
  },

  created() {
    this.setTimetagVideoAndOpenPlayer = this.checkClassRestrictionAndOpenPlayer(
      this.setTimetagVideoAndOpenPlayer
    );
  },
};

export default TimetagInHtmlMixin;
